﻿(function (angular, ToyotaConsts) {
  "use strict";

  // this is going to call the dealer service and return the region from the dealer

  angular.module("Toyota.Factories").factory("Region", [
    "$q",
    "$filter",
    "API",
    function ($q, $filter, API) {
      return function (postcode, suburb) {
        var url = $filter("formatArgs")(ToyotaConsts.API.Info.Dealers, [postcode, suburb]);

        var deferred = $q.defer();

        API.get(url).then(
          function (req) {
            if (!!req.data && req.data.results.length > 0) {
              deferred.resolve(req.data.results[0].region);
            } else {
              deferred.resolve("");
            }
          },
          function () {
            deferred.resolve("");
          }
        );

        return deferred.promise;
      };
    },
  ]);
})(window.angular, window.ToyotaConsts);
